export default {
  app: {
    dataProtection: {
      dataProtection: 'Zásady ochrany osobních dat',
      pageTitle: 'Zásady ochrany osobních dat - Elixír Tours',
    },
  },
};
